export enum AnalyticsServicesNameEnum {
  FIREBASE_ANALYTICS_SERVICE = 'firebase_analytics_service',
  SEGMENT_SERVICE = 'segment_service',
}
